module.exports = __webpack_public_path__ + "static/media/comment-alt-times.43d28a2e.svg";